﻿domReady(function () {

	var indexFormValidator = ui.validator(document.getElementById('indexForm'), {
		fields: {
			firstName: {
				errorLocation: 'callout',
				minLength: 1,
				maxLength: 35,
				pattern: function (patternData) { // patternData: { value, callback, config, event, field, element }
					if (!/^[a-zA-ZàèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÄËÏÖÜçÇßøØåÅæÆþÞðÐ\s'.,-]+$/.test(patternData.value)) {
						return false;
					}
					return true;
				},
				required: true,
				when: 'submit'
			},
			lastName: {
				errorLocation: 'callout',
				minLength: 1,
				maxLength: 35,
				pattern: function (patternData) { // patternData: { value, callback, config, event, field, element }
					if (!/^[a-zA-ZàèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÄËÏÖÜçÇßøØåÅæÆþÞðÐ\s'.,-]+$/.test(patternData.value)) {
						return false;
					}
					return true;
				},
				required: true,
				when: 'submit'
			},
			email: { required: true, pattern: 'email', errorLocation: 'callout' },
			password: { required: true, pattern: 'password', errorLocation: 'below', when: 'submit' },
			terms: { required: true, errorLocation: 'below' }
		},
		onSubmit: function (validatorData) { // validatorData: { element, valid, fields }
			if (validatorData.valid) {
				document.getElementById('cta').classList.add('loading', 'disabled');
				return true;
			}
			return false;
		},
		submitButton: document.getElementById('cta')
	});

});